import MicroModal from 'micromodal'

const init = () =>
  MicroModal.init( {
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    openTrigger: 'data-modal-open',
    closeTrigger: 'data-modal-close'
  } )

export default init
